module.exports = __webpack_public_path__ + "static/default_share_image-f23654a185bbcb515443094ca547979e.jpg";